var _CrossPlatformNavigat;
import React from 'react';
import { FeatureFlagProvider } from '@crehana/feature-flags/react';
import { CrossPlatformNavigationComponent } from "./cross-platform-navigation-component";
import { FEATURE_FLAGS_V5_KEYS } from "./feature-flags";
import { SidebarProvider } from "./sidebar-context";
import { jsx as _jsx } from "react/jsx-runtime";
export var CrossPlatformNavigationV2 = function CrossPlatformNavigationV2(props) {
  var organizationId = props.organizationId,
    email = props.email,
    organizationSlug = props.organizationSlug,
    sidebarType = props.sidebarType,
    handleUrl = props.handleUrl,
    mobileSidebarOpen = props.mobileSidebarOpen,
    hideMobileSidebar = props.hideMobileSidebar,
    productPlatform = props.productPlatform,
    _props$isGettingSideb = props.isGettingSidebarVersion,
    isGettingSidebarVersion = _props$isGettingSideb === void 0 ? false : _props$isGettingSideb;
  var featureFlagsV5 = FEATURE_FLAGS_V5_KEYS.map(function (flag) {
    return [flag, 'V5'];
  });
  return /*#__PURE__*/_jsx(FeatureFlagProvider, {
    flags: featureFlagsV5,
    organizationId: organizationId,
    children: /*#__PURE__*/_jsx(SidebarProvider, {
      email: email,
      organizationSlug: organizationSlug,
      sidebarType: sidebarType,
      handleUrl: handleUrl,
      productPlatform: productPlatform,
      mobileSidebarOpen: mobileSidebarOpen,
      hideMobileSidebar: hideMobileSidebar,
      organizationId: organizationId,
      isGettingSidebarVersion: isGettingSidebarVersion,
      children: _CrossPlatformNavigat || (_CrossPlatformNavigat = /*#__PURE__*/_jsx(CrossPlatformNavigationComponent, {}))
    })
  });
};